import { render, staticRenderFns } from "./cadrenegociacoes.vue?vue&type=template&id=60a0e2c4&"
import script from "./cadrenegociacoes.vue?vue&type=script&lang=js&"
export * from "./cadrenegociacoes.vue?vue&type=script&lang=js&"
import style0 from "./cadrenegociacoes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports